export default "__VITE_ASSET__CwTYY161__"